export default "__VITE_ASSET__CsG96yws__"